import { StyleSheet } from "react-native";

export const spinnerStyles = StyleSheet.create({
  spinner: {
    alignItems: "center",
    justifyContent: "center",
  },
});
